const features = [
  { icon: "ri-file-list-3-line", label: "Spreadsheet" },
  { icon: "ri-book-open-line", label: "Guide" },
  { icon: "ri-tools-line", label: "Tool" },
  { icon: "ri-scales-line", label: "Compare" },
  { icon: "ri-shield-check-line", label: "Safety" },
];

export default function AboutSection() {
  return (
    <section className="py-20 md:py-24 bg-background-950">
      <div className="max-w-5xl mx-auto px-6 md:px-10 text-center">
        <p className="text-foreground-400 text-sm font-label tracking-widest uppercase mb-4">
          What is CSSBuy Spreadsheet
        </p>
        <h2 className="text-3xl md:text-5xl font-heading font-bold text-white leading-tight mb-10">
          The Smart Way<br />
          To Manage CSSBuy<br />
          Product Lists
        </h2>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-14">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center px-8 py-3 rounded-full bg-white text-foreground-900 font-semibold text-sm whitespace-nowrap cursor-pointer hover:bg-white/90 transition-all duration-200"
          >
            CSSBuy Sheet
            <i className="ri-arrow-right-line ml-2"></i>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center px-8 py-3 rounded-full border border-white/20 text-white font-semibold text-sm whitespace-nowrap cursor-pointer hover:bg-white/10 transition-all duration-200"
          >
            Buy It Now
            <i className="ri-shopping-cart-line ml-2"></i>
          </a>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
          {features.map((feat) => (
            <div
              key={feat.label}
              className="flex items-center gap-3 bg-background-800/60 rounded-lg px-5 py-4"
            >
              <div className="w-8 h-8 flex items-center justify-center">
                <i className={`${feat.icon} text-white/70 text-lg`}></i>
              </div>
              <span className="text-white/80 text-sm font-medium whitespace-nowrap">
                {feat.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}